export const DEFAULT_MAX_FILES = 5
export const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024
export const IMAGE_MAX_FILE_SIZE = 10_000_000

// Same cap as the backend image uploads; photos under it are still optimized in the browser
export const IMAGE_UPLOAD_LIMITS = {
  maxFileSize: IMAGE_MAX_FILE_SIZE,
  maxOutputFileSize: IMAGE_MAX_FILE_SIZE,
} as const

export const AVATAR_IMAGE_OPTIMIZATION = { maxDimension: 1200 } as const
export const PHOTO_IMAGE_OPTIMIZATION = { maxDimension: 2000 } as const
export const INVALID_FILE_CONTENT_ERROR = 'invalid-file-content'
export const DEFAULT_ACCEPTED_TYPES: string[] = ['JPG', 'JPEG', 'PNG', 'PDF']
